// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  //apiUrl: 'http://192.168.150.18:8089/api/services/', // Andrea
  //documentUrl: 'http://192.168.150.18:8089/api/services/', // Andrea
  apiUrl: 'https://api.iila.n42.zone/api/services/', // Server
  documentUrl: 'https://api.iila.n42.zone/api/services/', // Server
};
